import { c as _c } from "react/compiler-runtime";
import { FlexColumn, ModalBody, ModalFooter, SkeletonBlock, SkeletonLine } from "@opensea/ui-kit";
export function FeesContentLayoutSkeleton() {
  const $ = _c(4);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <SkeletonBlock className="size-11 rounded-xl" />;
    t1 = <SkeletonLine className="h-5 w-[300px]" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ModalBody className="py-6 text-center"><FlexColumn className="items-center gap-6">{t0}{t1}<FlexColumn className="items-center gap-2"><SkeletonLine className="h-4 w-64" /><SkeletonLine className="h-4 w-56" /></FlexColumn></FlexColumn></ModalBody>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <>{t2}<ModalFooter><SkeletonLine className="h-10 w-full rounded-xl" /></ModalFooter></>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}